import { Clickable } from 'shared/ui/Clickable';

interface MenuItem {
  icon: string;
  text: string;
  onClick?: () => void;
  disabled?: boolean;
  sub?: (item: JSX.Element) => JSX.Element;
}

interface MenuItemProps {
  itemConf: MenuItem;
  onClick?: () => void;
}

const MenuItemComponent = ({ itemConf, onClick }: MenuItemProps) => {
  const handleClick = () => {
    itemConf.onClick?.();
    onClick?.();
  };
  const item = (
    <Clickable className={`d-block tool-menu-item ${itemConf.disabled ? 'text-disabled' : ''}`} onClick={handleClick}>
      <i className={`fa-regular ${itemConf.icon}`} />
      <span className="tool-menu-title">{itemConf.text}</span>
    </Clickable>
  );

  if (itemConf.sub) {
    return itemConf.sub(item);
  }
  return item;
};

interface ToolMenuProps {
  menuItems?: MenuItem[];
  onClick?: () => void;
}

const ToolMenu = ({ menuItems, onClick }: ToolMenuProps) => {
  return (
    <div className="tool-menu-wrapper">
      {menuItems?.map((item, idx) => (
        <MenuItemComponent itemConf={item} onClick={onClick} key={idx} />
      ))}
    </div>
  );
};

export default ToolMenu;
